import styled from 'styled-components/native'
import Typography from 'APP/Converse/Typography'

export const DailyBreakDownContainer = styled.View`
  flex: 1;
  padding-bottom: ${({ theme }) => theme.metrics.baseMargin * 0.3}px;
`

export const DailyBreakDownWeekday = styled(Typography)`
  padding-vertical: ${({ theme }) => theme.metrics.baseMargin / 2}px;
`

export const DailyBreakDownMinutes = styled(Typography)`
  padding-bottom: ${({ theme }) => theme.metrics.baseMargin / 4}px;
`

export const DailyBreakDownSubheader = styled(Typography)`
  padding-top: ${({ theme }) => theme.metrics.baseMargin / 2}px;
`

export const ProgressPillContainer = styled.View<{ disabled?: boolean }>`
  width: 16px;
  height: 28px;
  border-radius: 8px;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-end;
  overflow: hidden;
  background-color: ${({ theme, disabled }) =>
    disabled ? theme.colors.disabled : theme.colors.buttonLinen};
  ${({ disabled }) => disabled && 'opacity: 0.3;'}
`

export const ProgressPillFill = styled.View<{ grow: number }>`
  flex-grow: ${({ grow }) => grow};
  border-radius: 8px;
  background-color: ${({ theme }) => theme.colors.accent};
`

export const Container = styled.View`
  flex-direction: row;
  justify-content: space-between;
  padding-horizontal: ${({ theme }) => theme.metrics.baseMargin * 3}px;
  padding-top: ${({ theme }) => theme.metrics.baseMargin * 1.5}px;
  padding-bottom: ${({ theme }) => theme.metrics.baseMargin / 2}px;
`

export const DayContainer = styled.View`
  align-items: center;
  padding-vertical: ${({ theme }) => theme.metrics.baseMargin / 2}px;
`

export const DayLabel = styled(Typography)<{ isDisabled?: boolean }>`
  padding-top: ${({ theme }) => theme.metrics.baseMargin / 2.5}px;
  text-transform: uppercase;
  ${({ theme, isDisabled }) => isDisabled && `color: ${theme.colors.disabled};`}
`

export const Dot = styled.View`
  margin-top: 6px;
  width: 4px;
  height: 4px;
  border-radius: 2px;
  background-color: ${({ theme }) => theme.colors.text};
  align-self: center;
`
